import { FaroInsightsWrapper } from "@/grafana-faro"
import { CopilotTag } from "@/modules/patients/components/copilot-tag"
import {
  SuggestedAllergy,
  useHealthInformationCopilotContext,
} from "@/modules/patients/contexts/health-information-copilot-context"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { PatientAllergiesOutputFragment$data } from "@/modules/patients/services/__generated__/PatientAllergiesOutputFragment.graphql"
import { useDrawerStore } from "@/stores/useDrawerStore"

export const AllergyCopilots = ({
  onOpenAllergyDrawer,
  patientId,
  currentAllergies,
}: {
  onOpenAllergyDrawer: () => void
  patientId: string
  currentAllergies: PatientAllergiesOutputFragment$data["allergies"]
}) => {
  const appointmentId = useAppointmentParam()
  const copilotAllergies = useHealthInformationCopilotContext((v) => v.allergies.data)
  const setSelectedCopilotAllergy = useHealthInformationCopilotContext((v) => v.allergies.setSelected)
  const hideCopilotAllergy = useHealthInformationCopilotContext((v) => v.allergies.hide)
  const drawerName = useDrawerStore((state) => state.drawerName)

  const handleOpenAllergiesDrawer = (allergyCopilot: SuggestedAllergy) => {
    if (drawerName !== "AllergiesDrawer") {
      onOpenAllergyDrawer()
    }
    setSelectedCopilotAllergy(allergyCopilot)
    hideCopilotAllergy(allergyCopilot)
  }

  const filteredCopilotAllergies = copilotAllergies.filter(
    (copilot) =>
      !currentAllergies.some(
        (allergy) =>
          allergy.icdDiagnosis.diagnosisCode === copilot.diagnosis.diagnosisCode &&
          (allergy.comment ?? "") === (copilot.comment ?? ""),
      ),
  )

  return (
    filteredCopilotAllergies.length > 0 && (
      <div className="flex w-full flex-wrap items-center gap-2" data-testid="allergy-copilot-tag-section">
        {filteredCopilotAllergies.map((copilot) => (
          <CopilotTag
            key={copilot.diagnosis.diagnosisCode}
            id={copilot.diagnosis.diagnosisCode}
            name={copilot.comment ?? copilot.diagnosis.text}
            onCancel={() => {
              hideCopilotAllergy(copilot)
              FaroInsightsWrapper.pushEvent("health_information_copilot_allergy_reject", {
                conditionId: copilot.diagnosis.diagnosisCode,
                appointmentId: appointmentId ?? "",
                patientId: patientId,
              })
            }}
            onApprove={() => {
              handleOpenAllergiesDrawer(copilot)
              FaroInsightsWrapper.pushEvent("health_information_copilot_allergy_accept", {
                conditionId: copilot.diagnosis.diagnosisCode,
                appointmentId: appointmentId ?? "",
                patientId: patientId,
              })
            }}
          />
        ))}
      </div>
    )
  )
}
